
import { LevelFeature } from './../LevelFeature';
import Ramp from './Ramp';

// Phaser Editor doesn't allow us to implement directly, so we need to extend to be able to add the implementation.
export class RampFeature extends Ramp implements LevelFeature {

}
